import { gql } from "@apollo/client";
import { Query } from "@apollo/client/react/components";

import { Loader } from "semantic-ui-react";

import PopularTerm from "./PopularTerm";

const POPULAR_TERMS_QUERY = gql`
  query POPULAR_TERMS_QUERY {
    popularTerms {
      id
      label
      type
    }
  }
`;

const renderTerms = (termsToRender) =>
  termsToRender.map((term) => (
    <PopularTerm key={term.label + "Term"} term={term} />
  ));

const PopularTerms = ({ terms }) => {
  return (
    <div className="PopularTerms">
      {terms ? (
        renderTerms(terms)
      ) : (
        <Query query={POPULAR_TERMS_QUERY}>
          {({ error, loading, data }) => {
            if (error) return <p>Something went wrong</p>;

            if (loading)
              return (
                <>
                  <span></span>
                  <Loader active inline="centered" />
                </>
              );

            if (data?.popularTerms) return renderTerms(data.popularTerms);
            return null;
          }}
        </Query>
      )}
      <style jsx>
        {`
          .PopularTerms {
            width: 100%;
            display: grid;
            grid-template-columns: auto auto auto;
            grid-gap: 1em;
            position: relative;
            z-index: 2;
            margin-bottom: 30px;
          }
        `}
      </style>
    </div>
  );
};

export default PopularTerms;
